import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import {
  Eye,
  Trash,
  PaperPlaneTilt,
  Plus,
  DownloadSimple,
  UserCheck,
  Prohibit,
  DotsThreeOutlineVertical,
  Key,
} from "@phosphor-icons/react";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [
    {
      name: TableAction.EXPORT,
      label: "export",
      showLabel: true,
      allowed: true,
      show: true,
      action: null,
      variant: "secondary",
      icon: <DownloadSimple size={20} />,
    },
    {
      name: TableAction.CREATE,
      label: "create",
      showLabel: true,
      allowed: true,
      show: true,
      action: null,
      variant: "primary",
      icon: <Plus size={20} />,
    },
  ],
  rowActions: [
    {
      name: RowAction.DETAILS,
      label: "details",
      icon: <Eye size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("details", element);
      },
    },
    {
      name: "more",
      label: "more",
      allowed: true,
      show: true,
      icon: <DotsThreeOutlineVertical size={20} />,
      actions: [
        {
          name: "change-password",
          label: "change_password",
          icon: <Key size={20} />,
          allowed: true,
          show: true,
          data: "user",
          action: (element: any) => {
            console.log("change-password", element);
          },
        },
        {
          name: "reset-password-email",
          label: "send_reset_password",
          icon: <PaperPlaneTilt size={20} />,
          allowed: true,
          show: true,
          data: "user",
          action: (element: any) => {
            console.log("reset-password-email", element);
          },
        },
        {
          name: "active-account",
          label: "active_account",
          icon: <UserCheck size={20} />,
          allowed: true,
          show: (element: any, user: any) => {
            return element.user.status !== 1;
          },
          data: "user",
          action: (element: any) => {
            console.log("active-account", element);
          },
        },
        {
          name: "disable-account",
          label: "disable_account",
          icon: <Prohibit size={20} />,
          allowed: true,
          show: (element: any, user: any) => {
            return element.user.status === 1;
          },
          data: "user",
          action: (element: any) => {
            console.log("disable-account", element);
          },
        },
        {
          name: RowAction.DELETE,
          label: "delete",
          icon: <Trash size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
            console.log("delete", element);
          },
        },
      ],
    },
  ],
  rowConfiguration: {
    class: (element: any) => {
      return null;
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      sortable: true,
    },
    {
      name: "users.name",
      label: "name",
      key: "user.name",
      type: "string",
      show: true,
      sortable: true,
    },
    {
      name: "users.email",
      label: "email",
      key: "user.email",
      type: "string",
      show: true,
      sortable: true,
    },
    {
      name: "users.status",
      label: "status",
      key: "user.status",
      type: "translation",
      translation_prefix: "user_status",
      show: true,
      sortable: true,
    },
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functions: any, title?: string) => {
  const {
    indexFunction,
    exportFunction,
    initializeFunction,
    prepareRemoveFunction,
    detailsFunction,
    prepareResetPasswordFunction,
    prepareActiveOrDisableFunction,
    prepareChangePasswordFunction,
  } = functions;

  // Dynamic label based on context
  const nameLabel = title === "dealers" ? "dealer_name" : "name";

  // Update the name column label dynamically
  tableConfig.columns[1].label = nameLabel;

  tableConfig.actions[0].action = () => exportFunction();
  tableConfig.actions[1].action = () => initializeFunction();
  tableConfig.index = () => indexFunction();
  tableConfig.rowActions[0].action = (id: any) => detailsFunction(id);
  // more menu actions mapping
  tableConfig.rowActions[1].actions[0].action = (user: any) =>
    prepareChangePasswordFunction(user.id);
  tableConfig.rowActions[1].actions[1].action = (user: any) =>
    prepareResetPasswordFunction(user.email);
  tableConfig.rowActions[1].actions[2].action = (user: any) =>
    prepareActiveOrDisableFunction(user);
  tableConfig.rowActions[1].actions[3].action = (user: any) =>
    prepareActiveOrDisableFunction(user);
  tableConfig.rowActions[1].actions[4].action = (id: any) =>
    prepareRemoveFunction(id);
  return tableConfig;
};
export default getConfig;
